/**
 * Vue Router configuration with authentication and authorization
 */

import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { config, isDevelopment } from '@/config/env'
import { routerMiddleware } from '@/middleware'

// Create router instance
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }

        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            }
        }

        return { top: 0 }
    }
})

router.onError((error) => {
    console.error('Router error:', error)

    if (config.enableErrorReporting && !isDevelopment) {
    }
})

if (isDevelopment && config.enableDebug) {
    router.beforeEach((to, from) => {
        console.log(`🔀 Navigating from ${from.path} to ${to.path}`)
    })

    router.afterEach((to) => {
        console.log(`✅ Navigation completed: ${to.path}`)
    })
}

router.beforeEach((to, from, next) => {
    routerMiddleware(to, from, next, router)
})

export default router